/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Whether a storage transaction still counts in the stock calculation.
 */
export enum EnumStorageTransactionStatus {
    /**
     * The booking counts in the stock calculation.
     */
    Effective = 0,
    /**
     * The booking was cancelled, or is the counter booking of a cancellation. It is ignored in the stock calculation.
     */
    Cancelled = 1,
}
